import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/frontend/components/escape-room-details/details-page-client.tsx");
